import { Injectable } from '@angular/core';
import {
  ClientPoint,
  CreateStatusDistributionCenterResponse,
  ListCitiesRequest,
  ListCitiesResponse,
  ListDistributionCenterRequest,
  ListDistributionCenterResponse,
  CreateDistributionMassiveResponse,
  ListMassiveDeliverCompaniesResponse,
  ListMassiveDeliveryServiceRequest,
  ListMassiveDeliveryServiceResponse,
  UpdateMassiveDeliveryServiceRequest,
  UpdateMassiveDeliveryServiceResponse,
  ListMassiveDeliveryResponse,
  MassiveDeliveryServiceDetail,
  DistributionRequest,
  DistributionResponse,
  ClientPointRequest,
  MassiveDeliveryRequest,
  CreateDistributionMassiveRequest,
  ListMassiveDeliveryRequest,
} from '../api/gen_api_client/routing_pb';

import { City, ClientPointCompany, Company, MdDetail, LatLngToAddress } from '../../shared/models/interface/parametrizacion.interface';
import * as grpcWeb from 'grpc-web';
import {
  CityServiceClient,
  ClientPointServiceClient,
  CompanyServiceClient,
  MassiveDeliveryServiceClient,
} from '../../shared/api/gen_api_client/RoutingServiceClientPb';
import { GeologicServiceClient } from '../../shared/api/gen_api_client/GeologicServiceClientPb';
import { GeocodeRequest, GeocodeResponse, GeocodePositionRequest } from '../../shared/api/gen_api_client/geologic_pb';
import { environment } from '../../../../environments/environment';
import { GrpcFactoryService } from '../sharedServices/grpc-factory.service';
@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  public listMassiveDeliveryServiceRequest: ListMassiveDeliveryServiceRequest;
  public createDistributionMassiveResponse: CreateDistributionMassiveResponse;
  public mdRequests: MassiveDeliveryRequest[] = null;
  public selectedMdRequest: MassiveDeliveryRequest = null;
  public latLngToAddress: GeologicServiceClient;
  public latLngToAddressRequest: GeocodePositionRequest;
  public updateMassiveDeliveryServiceRequest: UpdateMassiveDeliveryServiceRequest;
  public massiveDeliveryServiceDetail: MassiveDeliveryServiceDetail;
  public geologicClient: GeologicServiceClient;
  public geologicRequest: GeocodeRequest;
  public selectedMdReq: any;
  public mdRequestDetails: MdDetail[] = null;
  public numberAddressSucess: number;
  public numberAddressError: number;
  public hostUrlBack: string;

  private cities: City[];
  private companies: Company[];
  private lisCitiesRequets: ListCitiesRequest;
  private clientCityService: CityServiceClient;
  private listMassiveCompaniesRequest: ListMassiveDeliveryRequest;
  private companyServiceClient: CompanyServiceClient;
  private listDistributionRequest: ListDistributionCenterRequest;
  private apiClient: ClientPointServiceClient;
  private distributionRequest: DistributionRequest;
  private updateClientePoint: ClientPointRequest;
  private clientPointClient: ClientPoint;
  private mdClient: MassiveDeliveryServiceClient;

  constructor(grpcFactoryService: GrpcFactoryService) {
    this.hostUrlBack = `${environment.hostnameMassive}`;
    this.lisCitiesRequets = new ListCitiesRequest();
    this.clientCityService = grpcFactoryService.create(CityServiceClient, this.hostUrlBack, 'CityServiceClient');
    this.listMassiveCompaniesRequest = new ListMassiveDeliveryRequest();
    this.companyServiceClient = grpcFactoryService.create(CompanyServiceClient, this.hostUrlBack, 'CompanyServiceClient');
    this.listDistributionRequest = new ListDistributionCenterRequest();
    this.apiClient = grpcFactoryService.create(ClientPointServiceClient, this.hostUrlBack, 'ClientPointServiceClient');
    this.distributionRequest = new DistributionRequest();
    this.updateClientePoint = new ClientPointRequest();
    this.clientPointClient = new ClientPoint();
    this.mdClient = grpcFactoryService.create(MassiveDeliveryServiceClient, this.hostUrlBack, 'MassiveDeliveryServiceClient');
    this.listMassiveDeliveryServiceRequest = new ListMassiveDeliveryServiceRequest();
    this.latLngToAddress = grpcFactoryService.create(GeologicServiceClient, this.hostUrlBack, 'GeologicServiceClient');
    this.latLngToAddressRequest = new GeocodePositionRequest();
    this.updateMassiveDeliveryServiceRequest = new UpdateMassiveDeliveryServiceRequest();
    this.massiveDeliveryServiceDetail = new MassiveDeliveryServiceDetail();
    this.geologicClient = grpcFactoryService.create(GeologicServiceClient, this.hostUrlBack, 'GeologicServiceClient');
    this.geologicRequest = new GeocodeRequest();
  }

  public handleCities(): Promise<City[]> {
    return new Promise((resolve, reject) => {
      this.clientCityService.listCities(this.lisCitiesRequets, {}, (err: grpcWeb.Error, response: ListCitiesResponse) => {
        if (err) {
          reject(err);
        } else {
          this.cities = response?.getCitiesList()?.map(clienta => {
            return {
              id: clienta.getId(),
              name: clienta.getName(),
              geoName: clienta.getGeoname(),
            };
          });
          resolve(this.cities);
        }
      });
    });
  }

  public handleCompanies(): Promise<Company[]> {
    return new Promise((resolve, reject) => {
      this.companyServiceClient.listMassiveDeliverCompanies(
        this.listMassiveCompaniesRequest,
        {},
        (err: grpcWeb.Error, response: ListMassiveDeliverCompaniesResponse) => {
          if (err) {
            reject(err);
          }
          if (response && response?.getCompaniesList()) {
            this.companies = response?.getCompaniesList()?.map(company => {
              return { id: company.getId(), name: company.getName() };
            });
            resolve(this.companies);
          }
        }
      );
    });
  }

  public handleCediByCompany(company: Company): Promise<ClientPointCompany[]> {
    return new Promise((resolve, reject) => {
      this.listDistributionRequest.setCompanyid(company.id);
      this.listDistributionRequest.setShowstores(false);
      this.apiClient.listDistributionCenter(
        this.listDistributionRequest,
        {},
        (err: grpcWeb.Error, response: ListDistributionCenterResponse) => {
          if (err) {
            reject(err);
          } else {
            const clientPoint = response
              ?.getClientpointsList()
              ?.map(cp => {
                return {
                  id: cp.getId(),
                  address: cp.getAddress(),
                  name: cp.getName(),
                  lat: cp.getLat(),
                  lng: cp.getLng(),
                  idCity: cp.getIdcity(),
                  city: cp.getNamecity(),
                  istDistributionCenter: cp.getIsdistributioncenter(),
                };
              })
              .filter(res => res !== undefined);
            resolve(clientPoint);
          }
        }
      );
    });
  }

  public createCediTableDataClient(companyId: number, fileId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      const request = new CreateDistributionMassiveRequest();
      request.setCompanyid(companyId);
      request.setShowstores(true);
      request.setFileid(fileId);
      this.apiClient.createDistributionCenterMassive(request, {}, (err: grpcWeb.Error, response: CreateDistributionMassiveResponse) => {
        if (err) {
          reject(err);
        } else {
          resolve(response?.toObject()?.clientsList);
        }
      });
    });
  }

  public deleteCeditableData(idCedi: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.distributionRequest.setId(+idCedi);
      this.apiClient.deleteDistributionCenter(this.distributionRequest, {}, (err: grpcWeb.Error, response: DistributionResponse) => {
        this.genericResponse(err, reject, resolve, response);
      });
    });
  }

  public createNewPointCedi(clientPoint: any, typeCedi: boolean, companyId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.clientPointClient.setAddress(clientPoint.coordinates.address);
      this.clientPointClient.setCompanyid(companyId);
      this.clientPointClient.setLat(clientPoint.coordinates.lat.toString());
      this.clientPointClient.setLng(clientPoint.coordinates.lng.toString());
      this.clientPointClient.setName(clientPoint.name);
      this.clientPointClient.setStatus('1');
      this.clientPointClient.setIdcity(clientPoint.city.id);
      this.clientPointClient.setIsdistributioncenter(typeCedi);
      this.clientPointClient.setNamecity(clientPoint.city.geoName);
      this.updateClientePoint.setClientpoint(this.clientPointClient);

      if (clientPoint.hasOwnProperty('id') && clientPoint.id !== 0) {
        this.clientPointClient.setId(clientPoint.id);
        this.apiClient.updateDistributionCenter(this.updateClientePoint, {}, (err: grpcWeb.Error, response: DistributionResponse) => {
          this.genericResponse(err, reject, resolve, response);
        });
      } else {
        this.apiClient.createDistributionCenter(
          this.updateClientePoint,
          {},
          (err: grpcWeb.Error, response: CreateStatusDistributionCenterResponse) => {
            if (err) {
              reject(err);
            } else {
              resolve(response?.getMessage());
            }
          }
        );
      }
    });
  }

  genericResponse(err: grpcWeb.Error, reject: any, resolve: any, response: any): void {
    if (err) {
      return reject(err);
    }
    resolve(response?.getResponse());
  }

  public handleFileData(): Promise<MdDetail[]> {
    return new Promise((resolve, reject) => {
      this.mdClient.listMassiveDelivery(
        this.listMassiveCompaniesRequest,
        {},
        (err: grpcWeb.Error, response: ListMassiveDeliveryResponse) => {
          if (err) {
            reject(err);
          }
          this.mdRequests = response?.getRequestsList();
          this.selectedMdRequest = this.mdRequests[this.mdRequests.length - 1];
          this.selectedMdReq = this.selectedMdRequest;
          this.mdRequests = [...this.mdRequests].reverse();
          this.loadMdServiceRequest(this.selectedMdRequest.getRequestid())
            .then(res => {
              resolve(res);
            })
            .catch(console.log);
        }
      );
    });
  }

  public loadMdServiceRequest(idService: number): Promise<MdDetail[]> {
    return new Promise((resolve, reject) => {
      this.listMassiveDeliveryServiceRequest.setRequestid(idService);
      this.mdClient.listMassiveDeliveryService(
        this.listMassiveDeliveryServiceRequest,
        {},
        (err: grpcWeb.Error, response: ListMassiveDeliveryServiceResponse) => {
          if (err) {
            reject(err);
          }

          this.mdRequestDetails = response
            ?.getServicesList()
            ?.reverse()
            ?.map(data => {
              return {
                address: data.getAddress(),
                clientId: data.getClientid(),
                clientName: data.getClientname(),
                orderId: data.getOrderid(),
                phone: data.getPhone(),
                requestId: data.getRequestid(),
                serviceId: data.getServiceid(),
                status: data.getStatus(),
                weight: data.getWeight(),
                lat: data.getLat(),
                lng: data.getLng(),
              };
            });
          resolve(this.mdRequestDetails);
        }
      );
    });
  }

  public handleLatToLng(country: string, lat: number, lng: number): Promise<LatLngToAddress> {
    return new Promise((resolve, reject) => {
      this.latLngToAddressRequest.setCountry(country);
      this.latLngToAddressRequest.setLatitude(lat);
      this.latLngToAddressRequest.setLongitude(lng);
      this.latLngToAddress.reverseGeocode(this.latLngToAddressRequest, {}, (err: grpcWeb.Error, response: GeocodeResponse) => {
        if (err) {
          reject(err);
        } else {
          resolve({
            address: response?.getAddress(),
            city: response?.getCity(),
            location: {
              lat: response?.getLocation()?.getLat(),
              lng: response?.getLocation()?.getLng(),
            },
          });
        }
      });
    });
  }

  public updateAdressPoint(editPoint: MdDetail[]): Promise<any> {
    return new Promise((resolve, reject) => {
      this.massiveDeliveryServiceDetail.setRequestid(editPoint[0].requestId);
      this.massiveDeliveryServiceDetail.setServiceid(editPoint[0].serviceId);
      this.massiveDeliveryServiceDetail.setClientid(editPoint[0].clientId);
      this.massiveDeliveryServiceDetail.setClientname(editPoint[0].clientName);
      this.massiveDeliveryServiceDetail.setAddress(editPoint[0].address);
      this.massiveDeliveryServiceDetail.setOrderid(editPoint[0].orderId);
      this.massiveDeliveryServiceDetail.setWeight(editPoint[0].weight);
      this.massiveDeliveryServiceDetail.setPhone(editPoint[0].phone);
      this.massiveDeliveryServiceDetail.setStatus(editPoint[0].status);
      this.massiveDeliveryServiceDetail.setLat(editPoint[0].lat);
      this.massiveDeliveryServiceDetail.setLng(editPoint[0].lng);
      this.updateMassiveDeliveryServiceRequest.setDetail(this.massiveDeliveryServiceDetail);
      this.mdClient.updateMassiveDeliveryService(
        this.updateMassiveDeliveryServiceRequest,
        {},
        (err: grpcWeb.Error, response: UpdateMassiveDeliveryServiceResponse) => {
          if (err) {
            reject(err);
          } else {
            resolve(response?.getStatus());
          }
        }
      );
    });
  }

  // public deleteAdressPoint(idService: number) : Promise<string> {
  //     return new Promise( (resolve, reject) => {
  //           this.deleteMassiveDeliveryServiceRequest.setIdmdservice(idService)
  //           this.mdClient.deleteMassiveDeliveryService( this.deleteMassiveDeliveryServiceRequest, {}, (
  //             err: grpcWeb.Error,
  //             response: DeleteMassiveDeliveryServiceResponse
  //           ) => {
  //             if (err) {
  //               reject(err);
  //             } else {
  //               resolve(response.getStatus());
  //             }
  //           }  )
  //     })
  // }

  public getLatLngFromAdress(address: string, countryGeoName: string, cityGeoName: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.geologicRequest.setAddress(address);
      this.geologicRequest.setCountry(countryGeoName);
      this.geologicRequest.setCity(cityGeoName);
      this.geologicClient.geocode(this.geologicRequest, {}, (err: grpcWeb.Error, response: GeocodeResponse) => {
        if (err) {
          reject(err);
        } else {
          resolve(response?.getLocation()?.toObject());
        }
      });
    });
  }
}
